import { render, staticRenderFns } from "./questions-react.vue?vue&type=template&id=497a6e1a&"
import script from "./questions-react.vue?vue&type=script&lang=js&"
export * from "./questions-react.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports